import { ToastProps } from '@/types/types';
import { AppDispatch } from '../index';
import { addToast, removeToast } from './toastSlice';

export const showToast =
  (toast: Omit<ToastProps, 'id'>) => (dispatch: AppDispatch) => {
    dispatch(addToast({ ...toast }));
  };
